import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "../Slices/AuthSlices/AuthSlice";
import subscriptionReducer from "../Slices/PricingSlices/SubscriptionSlice";
import apiReducer from "../Slices/MainPageSlices/ApiSlice";

const persistConfig = {
  key: "auth",
  storage,
  whitelist: ["accessToken", "user"],
};

const persistedAuthReducer = persistReducer(persistConfig, authReducer);

const store = configureStore({
  reducer: {
    auth: persistedAuthReducer,
    subscriptions: subscriptionReducer,
    api: apiReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
});

const persistor = persistStore(store);

export { store, persistor };
